<template>
	<div>
		<Breadcrumb></Breadcrumb>
		<el-row :gutter="20" type="flex">
		      <el-col :span="24">
		        <el-card class="mt-2">
		          <h4 class="fs_18 font-weight-semibold m-0 text-000 mb-3">库存明细</h4>
		          <div class="w-100 d-flex align-items-center flex-wrap">
					  <el-divider content-position="left">基本信息</el-divider>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									产品名称：
								</div>
								<div class="flex-1">
									{{data.data.name || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									产品编码：
								</div>
								<div class="flex-1">
									{{data.data.bn || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
                      <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									品牌：
								</div>
								<div class="flex-1">
									{{data.data.brand || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									型号：
								</div>
								<div class="flex-1">
									{{data.data.model || ''}}
								</div>
							 </div>
						  </el-col>
                      </el-row>
                      <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									规格：
								</div>
								<div class="flex-1">
									{{data.data.guige || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									类型：
								</div>
								<div class="flex-1">
									{{data.cate_name || ''}}
								</div>
							 </div>
						  </el-col>
                      </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									数量：
								</div>
								<div class="flex-1">
									{{data.data.nums || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									价格：
								</div>
								<div class="flex-1">
									¥{{data.data.price || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									金额：
								</div>
								<div class="flex-1">
									¥{{data.data.money || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									单位：
								</div>
								<div class="flex-1">
									{{data.data.unit || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									采购人：
								</div>
								<div class="flex-1">
									{{data.data.procure_name || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									采购时间：
								</div>
								<div class="flex-1">
									{{data.data.procure_time || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
					  <el-divider content-position="left">厂家信息</el-divider>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									厂家/供应商：
								</div>
								<div class="flex-1">
									{{data.data.manufactor || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									国标号：
								</div>
								<div class="flex-1">
									{{data.data.gbcode || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									生产日期：
								</div>
								<div class="flex-1">
									{{data.data.made_time || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									维修时间：
								</div>
								<div class="flex-1">
									{{data.data.wx_time || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									生产批次：
								</div>
								<div class="flex-1">
									{{data.data.batch || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									有效期限：
								</div>
								<div class="flex-1">
									{{data.data.expirare_date || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									保险期限：
								</div>
								<div class="flex-1">
									{{data.data.bx_date || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
	
						  </el-col>
					  </el-row>
					  <el-divider content-position="left">其他信息</el-divider>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									创建时间：
								</div>
								<div class="flex-1">
									{{data.ctime || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									备注信息：
								</div>
								<div class="flex-1">
									{{data.data.brief || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
		          </div>
		        </el-card>
		      </el-col>
		</el-row>
	</div>
</template>

<script>
	import common from "@/common/mixins/common.js"
	import Breadcrumb from '@/components/Breadcrumb';
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			Breadcrumb
		},
		data() {
			return {
				preUrl: 'kcgl_log',
				autoRequest: false,
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				id:'',
				data:{},
			}
		},
		mounted() {
			if(this.$route.query.id){
				this.id = this.$route.query.id
				this.getDetail()
			}
		},
		methods:{
			getDetail() {
			  this.axios.get(`/manage/${this.preUrl}/detail`, {
			    params: {
					id:this.id
				}
			  }).then(res => {
			    this.data = res.data
			  })
			},
		}
	}
</script>

<style>
</style>